<template>
    <g-media-object left-margin="5" class="product-overview-card">
        <template slot="left">
            <div class="product-image" :style="{'background-image': `url(${imageUrl})`}"></div>
        </template>
        <template>
            <g-typography tag="p" :value="product.name"/>
            <g-typography tag="p" color="secondary" :value="productInfo"/>
        </template>
    </g-media-object>
</template>
<script>
    import ProductsMixin from "../mixins/ProductsMixin";

    export default {
        name: 'SelectedProductOverviewCard',
        mixins: [
            ProductsMixin,
        ],
        props: {
            product: {
                type: Object,
            },
        }
    }
</script>
<style lang="scss" scoped>
    .product-image {
        border: $g-border-radius;
        width: 64px;
        height: 64px;
        background-position: center;
        background-size: cover;
        border-radius: $g-border-radius;
    }

    .product-overview-card {
        margin-bottom: $g-spacing-3;
    }
</style>
